import * as _ from 'underscore';
import { weixinShare, weixinShareCallback, wxConfigReady, } from '@ivy/fts/weixin';
import { appGolbal } from '@ivy/fts/appGlobal';
import { isWeixin } from '@ivy/fts/utils';
import ivyStore from '@ivy/fts/ivyStore';
import { sleep } from '@ivy/fts/utils';
/**
 * 根据window.devicePixelRatio获取像素比
 */
function DPR() {
    if (window.devicePixelRatio && window.devicePixelRatio > 1) {
        return window.devicePixelRatio;
    }
    return 1;
}
/**
 * 将传入值转为整数
 */
function parseValue(value) {
    return parseInt(value, 10);
}
export async function setShare(opt) {
    await wxConfigReady();
    await weixinShare(opt);
}
// 验证手机号
export function checkPhone(phone) {
    return /^1[345678]\d{9}$/.test(phone);
}
// 验证验证码
export function checkCode(code) {
    return /^\d{4}$/.test(code);
}
// 阿里云图片获取指定尺寸的图片
export function transAliImgResize(url, width, height, mode = 'mfit') {
    // return igorePrefex(`${url}?x-oss-process=image/resize,m_${mode},h_${height},w_${width}`)
    return `${url}?x-oss-process=image/resize,m_${mode},h_${height},w_${width}`;
}
// 去掉网络协议请求头
export function igorePrefex(url) {
    return url.replace(/https?:(\/\/.+\.)/, '$1');
}
//  * 获取数据类型
//  * getType(5); // => "Number"
//  * getType({}); // => "Object"
//  * getType(/foo/); // => "RegExp"
//  * getType(''); // => "String"
//  * getType(true); // => "Boolean"
//  * getType([]); // => "Array"
//  * getType(undefined); // => "Window"
//  * getType(Element); // => "Constructor"
export function getType(object) {
    return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
}
export async function getAppInfo() {
    await sleep(50);
    let all = await appGolbal.nativeGetInfo('all');
    if (typeof all === 'string') {
        all = JSON.parse(all);
    }
    return all;
}
export function getUserBookStatus(book) {
    if (book.is_recorded && book.is_completed)
        return 'finished';
    if (book.is_recorded)
        return 'recorded';
    if (book.is_completed)
        return 'completed';
    return 'init';
}
export function timeOffset(operation, time = new Date()) {
    time = new Date(time);
    let [_1, op, unit] = operation.match(/([+|-]\d+)([smhDdMY])/);
    let n = +op;
    if (unit === 's') {
        time.setSeconds(time.getSeconds() + n);
    }
    else if (unit === 'm') {
        time.setMinutes(time.getMinutes() + n);
    }
    else if (unit === 'h') {
        time.setHours(time.getHours() + n);
    }
    else if (unit === 'D' || unit === 'd') {
        time.setDate(time.getDate() + n);
    }
    else if (unit === 'M') {
        time.setMonth(time.getMonth() + n);
    }
    else if (unit === 'Y') {
        time.setFullYear(time.getFullYear() + n);
    }
    else {
        throw new Error(`bad time operation: ${operation}`);
    }
    return time;
}
export async function shareBook(book, shareData = {}, cb) {
    await wxConfigReady();
    await ivyStore.login();
    let userInfo = ivyStore.logined;
    let babyName = (userInfo.user && (userInfo.user.baby_nick || userInfo.user.baby_name)) ||
        '宝贝';
    let callback = cb ? cb : () => { };
    let wxShareData = getReplacedObj({
        title: shareData.title || '快来一起读绘本吧',
        desc: shareData.content || '',
        imgUrl: shareData.pic_url,
        link: shareData.url,
    }, { babyName });
    await weixinShareCallback(wxShareData, callback);
}
export function deepReplaceObj(obj, subs) {
    if (typeof obj !== 'string' && typeof obj !== 'object')
        return obj;
    if (typeof obj === 'string')
        return getReplacedStr(obj, subs);
    for (let k in obj) {
        obj[k] = deepReplaceObj(obj[k], subs);
    }
    return obj;
}
export function getReplacedObj(obj, subs) {
    return _.mapObject(obj, v => getReplacedStr(v, subs));
}
export function getReplacedStr(str, subs) {
    if (typeof str !== 'string') {
        return str;
    }
    for (let k in subs) {
        str = str.replace(new RegExp(`{${k}}`, 'gm'), subs[k]);
    }
    return str;
}
export function isZfb() {
    return window.navigator.userAgent.toLowerCase().includes('alipayclient');
}
export function getQrcodeRoute() {
    let qrCodeRoute;
    if (isWeixin()) {
        qrCodeRoute = 'qrCode2';
    }
    else if (isZfb()) {
        qrCodeRoute = 'zfbRegister';
    }
    else {
        qrCodeRoute = 'activation';
    }
    return qrCodeRoute;
}
export function addYMPutData() {
    let src = 'https://s4.cnzz.com/z_stat.php?id=1279341518&web_id=1279341518';
    let cuzz = `var _czc = _czc || [];
  _czc.push(["_setAccount", "1279341518"]);`;
    loadScriptString(cuzz);
    let script_dom = document.createElement('script');
    script_dom.src = src;
    script_dom.type = 'text/javascript';
    document.head.appendChild(script_dom);
}
function loadScriptString(code) {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    try {
        script.appendChild(document.createTextNode(code));
    }
    catch (ex) {
        script.text = code;
    }
    document.head.appendChild(script);
}
